var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsThreeVerticalIcon = function SvgDotsThreeVerticalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 16a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M16 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
  })));
};
export default SvgDotsThreeVerticalIcon;